/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useEffect, useRef, useState } from 'react';
import '../TrainingWebinarJoinVC/style.css';
import LeftBlock from '../TrainingWebinarJoinVC/Components/LeftBlock';
import { useParams } from 'react-router-dom';
import { getTNndWebById } from '../containers/actions/training_actions';
import Loading from '../components/Common/Loaders/FullWidthLoader/Loading';

const UnAuthHoc = (WrappedComponent) =>
{
	return function NewComponent()
	{
		const [ loading, setLoading ] = useState<boolean>(true);
		const [ details, setDetails ] = useState<any>({});
		const params:any = useParams();
		const paramsRef = useRef<any>(null);
		const email:any = new URLSearchParams(window.location.search).get('email');

		const getDetails = async () =>
		{
			const query:any = {
				id : window.atob(params?.id)
			};

			if (email)
			{
				query.email = window.atob(email);
			}
			try
			{
				const res = await getTNndWebById(query);

				if (res?.status)
				{
					setDetails(res?.data);
					setLoading(false);
				}
			}
			catch (err:any)
			{
				console.log(err, '---*******');
				setLoading(false);
			}
		};

		useEffect(() =>
		{
			if (params?.id && paramsRef.current !== params?.id)
			{
				paramsRef.current = params?.id;
				getDetails();
			}
			else
			{
				setLoading(false);
			}
		}, [ params ]);

		return (
			<div className='flexCol unAuthBg alignCntr justifyCntr'>
				{loading && <Loading />}
				<div className='resColRow unAuthInnerCntr '>
					<div className='unAuthLeft'>
						<LeftBlock joinDetails={details} />
					</div>
					<div className='unAuthRight'>
						{!loading &&
						<React.Suspense>
							<WrappedComponent joinDetails={details} />
						</React.Suspense>}
					</div>
				</div>
				<div />
			</div>
		);
	};
};

export default UnAuthHoc;
